import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AspectCache, FactionCache, PrototypeCache } from '@xanadu/cache';
import { Register, NodeViewComponent } from '@xanadu/core';
import { Node, Faction, Aspect, Prototype, NodeModel } from '@xanadu/model';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'app-aspect-view',
    templateUrl: './aspect-view.component.html',
    styleUrls: ['./aspect-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('aspect-view')
export class AspectViewComponent extends NodeViewComponent<Prototype | Aspect | Faction> {
    private readonly factionCache = inject(FactionCache);
    private readonly aspectCache = inject(AspectCache);
    private readonly prototypeCache = inject(PrototypeCache);

    protected get nodeType(): string | undefined {
        return 'aspect';
    }

    protected getPanel(model: NodeModel) {
        const node = model.node;
        const custome = model.custome;

        if (node instanceof Faction) {
            return {
                node: node,
                component: 'faction-panel'
            };
        } else if (node instanceof Prototype) {
            return {
                node: node,
                custome,
                component: 'prototype-panel'
            };
        } else if (node instanceof Aspect) {
            return {
                node,
                custome,
                component: 'aspect-panel'
            };
        }
    }

    protected delete(node: Node): Observable<Prototype | Aspect | Faction> {
        return this.dataService.delete<Prototype | Aspect | Faction>(node as any)
            .pipe(switchMap(node => {
                if (node instanceof Prototype) {
                    this.prototypeCache.update();
                } else if (node instanceof Aspect) {
                    this.aspectCache.update();
                } else if (node instanceof Faction) {
                    this.factionCache.update();
                }

                return of(node);
            }));
    }
}
